const data = {
  data: [
    {
      id: 1,
      code: 'es',
      name: 'Español',
      created_at: '2021-05-25T15:33:58.000000Z',
      updated_at: '2021-05-25T15:33:58.000000Z',
      deleted_at: null
    },
    {
      id: 2,
      code: 'en',
      name: 'English',
      created_at: '2021-05-25T15:33:58.000000Z',
      updated_at: '2021-05-25T15:33:58.000000Z',
      deleted_at: null
    },
    {
      id: 3,
      code: 'ca',
      name: 'Català',
      created_at: '2021-05-25T15:33:58.000000Z',
      updated_at: '2021-05-25T15:33:58.000000Z',
      deleted_at: null
    },
    {
      id: 4,
      code: 'en',
      name: 'English',
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  ],
  meta: {
    search: {}
  }
}

export default data
